/* Frimino Profil 2.0 · rolige overganger (CA2-80)
   Friminos seksjoner (.fr-seksjon) toner rolig inn når de kommer til syne, diskret og likt overalt.
   - Det som står i vinduet når siden åpnes, vises med en gang.
   - Ingen overganger når besøkende har bedt om mindre bevegelse, i temaredigereren, eller i
     nettlesere uten IntersectionObserver. Da står alt slik det er, uten skjult innhold.
   Hover på produktkortet (bilde nummer to) står i frimino-seksjoner.css. */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.Shopify && window.Shopify.designMode) return;

  function start() {
    var hoyde = window.innerHeight || 800;
    var seksjoner = [].slice.call(document.querySelectorAll('.fr-seksjon')).filter(function (s) {
      return s.getBoundingClientRect().top > hoyde * 0.9;
    });
    if (!seksjoner.length) return;
    var obs = new IntersectionObserver(function (poster) {
      poster.forEach(function (p) {
        if (!p.isIntersecting) return;
        p.target.classList.add('fr-synlig');
        obs.unobserve(p.target);
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.04 });
    seksjoner.forEach(function (s) {
      s.classList.add('fr-toner');
      obs.observe(s);
    });
    // Hopper leseren forbi (lenke til et anker, End-tasten), vises det som er passert med en gang.
    var venter = false;
    window.addEventListener('scroll', function () {
      if (venter) return;
      venter = true;
      window.requestAnimationFrame(function () {
        venter = false;
        var grense = window.innerHeight || 800;
        seksjoner.forEach(function (s) {
          if (!s.classList.contains('fr-synlig') && s.getBoundingClientRect().top < grense) {
            s.classList.add('fr-synlig');
            obs.unobserve(s);
          }
        });
      });
    }, { passive: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
